// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"illustration_wrapper__zyZ6d","image":"illustration_image__2iwX7"};